import { ButtonLink } from '../../elements/button-link'
import ModuleWrapper from '../../helpers/module-wrapper'

import { useEntity } from '@uswitch/ev-utils/context/selectors'

const ConnectedButton = ({ entity, ...rest }) => {
  const { text, ...props } = useEntity(entity)
  return (
    <ButtonLink {...rest} {...props}>
      {text}
    </ButtonLink>
  )
}

export default ({ entries = [], options = {} }) => {
  const { spacingTop = 'lg', spacingBottom = 'lg' } = options

  // TODO: check if moduleWrapper is needed
  return (
    <div sx={{ textAlign: ['left', 'right'] }}>
      <ModuleWrapper spacingTop={spacingTop} spacingBottom={spacingBottom}>
        <div
          sx={theme => ({
            display: ['block', 'inline-flex'],
            flexDirection: 'row-reverse',
            marginLeft: -theme.space.sm,
            marginBottom: -theme.space.sm,
          })}
        >
          <For index='key' each='entry' of={entries}>
            <ConnectedButton
              key={key}
              entity={entry}
              sx={{ marginBottom: 'sm', marginLeft: 'sm' }}
            />
          </For>
        </div>
      </ModuleWrapper>
    </div>
  )
}
